const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * PRODUCT CUSTOMIZER EVENTS                                                  *
 * ----------                                                                 *
 * - Add to cart                                                              *
 * - Edition started                                                          *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  const customizerIds = ANALYTICS_EVENTS.PAYLOADS.productCustomizerEditionStarted.customizerId;
  const customizerItems = {
    [customizerIds.bracelet]: 'bracelet',
    [customizerIds.keyring]: 'key-ring',
  };

  // Add to cart
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productCustomizerAddedToCart,
    ({ customizerId }) => {
      pushEvent(
        createCustomEventGA4('product_custom', [
          ['action', 'add'],
          ['item', customizerItems[customizerId]],
        ]),
      );
    },
  );

  // Edition started
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.productCustomizerEditionStarted,
    ({ customizerId }) => {
      pushEvent(
        createCustomEventGA4('product_custom', [
          ['action', 'edit'],
          ['item', customizerItems[customizerId]],
        ]),
      );
    },
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
